export default __webpack_public_path__ + "static/media/c002-PPII-6.afd6e099.svg";